















import Vue from "vue";

// Vue components
import AppPage from "@/components/AppPage.vue";
import ProfilesTable from "@/views/App/Tools/UserManagement/ProfilesTable.vue";
import UsersTable from "@/views/App/Tools/UserManagement/UsersTable.vue";

export default Vue.extend({
    components: {
        AppPage,
        ProfilesTable,
        UsersTable,
    },
    methods: {
        getProfiles() {
            this.$refs.profilesTable.getProfiles();
        },
        getUsers() {
            this.$refs.usersTable.getUsers();
        },
        filterUsersTable(profileName: string) {
            this.$refs.usersTable.filterUsersTable(profileName);
        },
    },
});
